module.exports = __webpack_public_path__ + "media/images/c1-dbcbddf55524214dd3f07f196327b0ea.jpg";